export enum BorrowerAddressTypes {
  Present = 0,
  Mailing = 1,
  Previous = 2,
}

export type BorrowerAddressOwnershipTypes = 'NotAssigned' | 'Own' | 'Rent' | 'LivingRentFree';
